import { UmbracoTypes } from '~/lib/data-contract';
import { UmbracoImage } from '~/shared/components/Image';
import { StyledLinkAnimationText } from '~/shared/styles/Link';
import { Arrow, Categories, ImageWrapper, Link, Name, Text } from './styled';

type Props = UmbracoTypes.IM31DynamicCategoryListBlock;

export const DynamicCategoryListBlock = ({ categories }: Props) => (
    <Categories>
        {categories?.map((category, index) => (
            <li key={category.link.id || category.image.id || `category-${index}`}>
                <Link
                    prefetch={false}
                    href={category.link.url}
                    animation="reverse"
                    multipleElements
                >
                    <CategoryImage image={category.image} />
                    <Name>
                        <StyledLinkAnimationText>
                            <Text>{category.link.title}</Text>
                        </StyledLinkAnimationText>
                        <Arrow />
                    </Name>
                </Link>
            </li>
        ))}
    </Categories>
);

const CategoryImage = ({ image }: { image: UmbracoTypes.Category['image'] }) => (
    <ImageWrapper>
        <UmbracoImage
            src={image.src}
            fill
            sizes="50vw"
            alt={image.name ?? ''}
            style={{ objectFit: 'cover' }}
        />
    </ImageWrapper>
);
